import React from "react";
import "./EmptyPage.scss";
import emptyDashboard from "../../assets/images/empty-dashboard.png";
import {Button} from "../button/Button";
import {faSquarePlus} from "@fortawesome/free-solid-svg-icons";

function EmptyPage({onSubmit}) {

    return (
        <div className="container-column empty-dashboard">
            <h2>Nothing to Show Yet</h2>
            <p>You have not added any applications yet. Click the button below to add a new application.</p>
            <img src={emptyDashboard} alt="Empty Dashboard"/>
            <Button
                label="Add Application"
                icon={faSquarePlus}
                variant="primary"
                size="xl"
                onClick={onSubmit}
            />
        </div>
    );
}

export {EmptyPage};
